import { InfoIcon } from 'foundations-assets';
import { Box } from 'foundations-components/transitional/components/Box';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportCardHeaderTitle = ({
  header,
  description
}) => {
  return (
    /*#__PURE__*/
    // Yes, this is weird that we have to wrap the TruncateString in another TruncateString
    // but otherwise the truncation doesn't work properly inside the CardHeader component
    _jsx(TruncateString, {
      children: /*#__PURE__*/_jsx(TruncateString, {
        useFlex: true,
        fixedChildren: description && /*#__PURE__*/_jsx(Tooltip, {
          title: description,
          children: /*#__PURE__*/_jsx(Box, {
            paddingInlineStart: "200",
            children: /*#__PURE__*/_jsx(InfoIcon, {
              size: "300",
              color: "icon-core-subtle"
            })
          })
        }),
        children: header
      })
    })
  );
};